import axios, { AxiosResponse } from "axios";

export default {
  checkUserByEds: (xmlSigned: string) =>
    axios.post(
      "/services/isnaportal/open-api/register/check-user-by-eds",
      btoa(unescape(encodeURIComponent(xmlSigned))),
      {
        headers: {
          "Content-Type": "application/xml",
        },
      }
    ),
  getToken: () => axios.get("/services/isnaportal/open-api/register/generate-token"),
  createUserByEds: (data: any) => axios.post("/services/isnaportal/open-api/register/create-user-by-eds", data),
  getAgreement: () => axios.get('/services/isnaportal/open-api/register/privacy-policy'),
  authUserByEds: (data: any) => axios.post('/services/isnaportal/open-api/keycloak/auth/user-by-eds', data),
  checkTaxpayerCodeUrl: (params: any, tokenStr: string)=>
      axios.get(`/services/isnaportal/api/user/check-taxpayercode`, {
          params,
          headers: {"Authorization" : `${tokenStr}`}
      }),
};
